import { MODALS } from 'common/domain/constants';

class LoansMandatoryInsuranceModalController {

  constructor() {}

  get modal() {
    return $(MODALS.MANDATORY_INSURANCE);
  }

  requestIsFailed() {
    return this.error === true;
  }

  closeModal() {
    this.modal.modal('hide');
  }

  onDismiss() {
    this.closeModal();
  }

}

export default LoansMandatoryInsuranceModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansMandatoryInsuranceModal/loansMandatoryInsuranceModal.controller.js